<template>
	<div class="header">
		<vs-popup
			:active.sync="showAllNotificationPopUp"
			title="Notifications"
			style="z-index: 52999"
		>
			<AllPersonalNotificationPopup
				:unreadNotification="$props.listNotification"
				:show="showAllNotification"
				:allListNotification="allPersoNotification"
				:key="refreshKey"
			/>
		</vs-popup>
		<div class="container">
			<div
				class="notification"
				id="notification_icon"
				v-on:click="notificationIconTapped()"
			>
				<div
					id="notif_icon"
					style="
						margin-right: 20px;
						margin-top: 4px;
						background: transparent !important;
						padding: 0;
						overflow: visible;
						cursor: pointer;
					"
				>
					<vx-tooltip text="Notifications">
						<feather-icon
							icon="BellIcon"
							class
							:key="refreshCount"
							:badge="newNotifCount"
						/>
					</vx-tooltip>
				</div>

				<ul class="notification-menu-header" id="notif_header">
					<li class="bg-primary notification-top">
						<h3
							class="text-white"
							style="
								display: flex;
								align-items: center;
								justify-content: center;
							"
						>
							{{ newNotifCount > 0 ? newNotifCount + " Notifications" : "" }}
						</h3>
					</li>
				</ul>
				<div class="notification-menu" id="notif_main">
					<vs-table :data="unreadNotifications" style="overflow-x: hidden">
						<template slot-scope="{ data }">
							<vs-tr
								:key="indextr"
								v-for="(ntf, indextr) in data"
								:style="
									ntf.is_viewed == 0
										? `background-color: #F3F2F7`
										: `background-color: #fff`
								"
							>
								<vs-td :data="data[indextr].email">
									<vs-icon
										:id="ntf.index"
										:icon="ntf.icon"
										icon-pack="material-icons"
										size="25px"
										:color="ntf.color"
									></vs-icon>
								</vs-td>

								<vs-td
									:data="data[indextr].username"
									style="width: 23rem; height: 5rem; overflow: hidden"
								>
									<div
										v-on:click="notificationTapped(ntf.id, ntf.route, ntf.args)"
										style="cursor: pointer"
									>
										<p
											:style="
												`font-size: 10px; font-weight: 600; color:` +
												ntf.color +
												`;`
											"
										>
											{{ ntf.description }}
										</p>
									</div>
								</vs-td>

								<vs-td :data="data[indextr].id">
									<div
										:class="
											ntf.need_check == 1
												? `with-check pb-2`
												: `without-check pb -2`
										"
									>
										<vs-button
											v-if="ntf.need_check == 1"
											size="small"
											color="#F3F2F7"
											gradient-color-secondary="#F3F2F7"
											type="gradient"
											@click.stop="checkButtonTapped(ntf.id)"
											hide-details
										>
											<vs-icon
												:icon="ntf.is_viewed == 1 ? 'check' : 'visibility'"
												size="small"
												:color="ntf.is_viewed == 1 ? 'success' : 'warning'"
											></vs-icon
										></vs-button>
										<small class="mt-1 whitespace-no-wrap">{{
											elapsedTime(ntf.creation_date)
										}}</small>
									</div>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
				<!-- <ul class="notification-menu" id = "notif_main">
                <div>
                <li v-for="ntf in unreadNotifications" :key="ntf.index" class="flex justify-between notification cursor-pointer active borderlist" >
                  <div class="flex items-start pl-4 py-4 notification-container" :style="ntf.is_viewed == 0? `background-color: #F3F2F7`:`background-color: #fff`" >
			<div class="flex items-start" v-on:click="notificationTapped(ntf.id,ntf.route, ntf.args)" >
			<vs-icon :id= "ntf.index" :icon="ntf.icon" icon-pack="material-icons" size="25px" :color ="ntf.color"  ></vs-icon>
                        <div class="ml-5 mx-2" style = "width: 20rem; height: 5rem; overflow: hidden;">
                <p :style= "`font-size: 10px; font-weight: 600; color:`+ntf.color+`;`">{{ ntf.description }}</p>
              </div>
            </div>
			<div :class="ntf.need_check == 1 ?`with-check pb-2`:`without-check pb -2`">
			<vs-button

				v-if = "ntf.need_check ==1"
                size="small"
                color="#F3F2F7"
				gradient-color-secondary="#F3F2F7" type="gradient"
				@click.stop = "checkButtonTapped(ntf.id)"
                hide-details
              >
			<vs-icon  :icon="ntf.is_viewed ==1 ? 'check' : 'visibility'" size="small" :color="ntf.is_viewed ==1 ?'success':'warning'"></vs-icon></vs-button>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.creation_date) }}</small>

			</div>
				</div>

                </li>
              </div>
              </ul> -->
				<ul
					class="notification-menu-footer"
					id="notif_footer"
					style="background-color: #f6f6f6; font-weight: 600"
				>
					<li class="notification-dowm">
						<div
							class="cursor-pointer"
							style="color: white; display: flex"
							v-on:click="showAllNotificationTapped()"
						>
							<span style="display: flex; align-items: center; color: #08afb8">
								Voir toutes les notifications
							</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import Contracts from "@/views/dashboard/Contracts.vue";
import moment from "moment";
import Vue from "vue";
import VueCookies from "vue-cookies";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import AllPersonalNotificationPopup from "@/components/popups/AllPersonalNotificationPopup";
import store from "@/store/store";
export default {
	props: {
		listNotification: Array,
		newCount: Number,
	},
	components: {
		AllPersonalNotificationPopup,
		Contracts,
		VuePerfectScrollbar,
	},
	data() {
		return {
			refreshKey: 0,
			showAllNotificationPopUp: false,
			notifPopup: false,
			refreshCount: 0,
			doReload: false,
			toogleReload: true,
			selected: "",
			newNotifCount: 0,
			showAllNotification: false,
			staticNewCountNotification: null,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},

	computed: {
		allPersoNotification() {
			return store.state.personalNotification.data;
		},
		stateNotifPopUp: () => {
			return store.state.isNotifPopUp;
		},
		allContracts: () => {
			return store.state.contracts_contracts_users;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		unreadNotifications() {
			return this.$props.listNotification
				? this.$props.listNotification.filter(
						(ele) =>
							this.isOneHourAfter(ele.creation_date, ele) && ele.is_viewed == 0
				  )
				: this.$props.listNotification;
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
	},
	created() {
		store.dispatch("getAllContractsWithContractsUsers");
	},
	watch: {
		"$route.query"() {
			if (this.doReload) this.$router.go();
		},
		toogleReload() {
			this.$router.go();
		},
		unreadNotifications() {
			let unread = this.unreadNotifications.filter((ele) => ele.is_viewed == 0);
			this.newNotifCount = unread.length;
		},
	},

	methods: {
		doStuff() {
			$("#notifKey").trigger("click");
			//console.log(this.$refs.notifKey.vsDropdownVisible);
		},
		async notificationTapped(id, route, args) {
			window.beforeContract = true;
			window.fromNotif = true;
			if (route == "contracts") {
				let ComponentClass = Vue.extend(Contracts);
				let contractPopup = new ComponentClass({
					propsData: {
						contract: this.selectedContract,
						popupActive: this.showContractPopup,
						router: this.$router,
						// apiUrl: this.apiUrl
					},
				});
				this.$refs["popupContract"] = contractPopup;
				this.$refs.popupContract.showContactInfoPopup(JSON.parse(args));
			} else if (route == "commercial_notification") {
				this.$emit("rc-show-popup");
			}
		},
		checkButtonTapped(id) {
			this.$http
				.post("personal_notification/update/check/" + id)
				//sets notification viewed to true for this user
				.then(() =>
					this.$store.dispatch(
						"getPersonalNotificationList",
						this.activeUser.id
					)
				)
				.catch((err) => console.log(err));
		},
		notificationIconTapped() {
			let notif_top = $(document.getElementById("notification_icon")).offset()
				.top;
			window.fromNotif = true;
			window.isNotifPopUp = $(".notification-menu").is(":visible");
			this.notifPopup = $(".notification-menu").is(":visible");
			document.getElementById("notif_header").style.top =
				notif_top.toString() + "px";
			document.getElementById("notif_main").style.top =
				(notif_top + 45).toString() + "px";
			document.getElementById("notif_footer").style.top =
				(notif_top + 45 + 300).toString() + "px";
			this.$store
				.dispatch("setNewCountPersonalNotification", this.activeUser.id)
				.then(() =>
					this.$store.dispatch(
						"getPersonalNotificationList",
						this.activeUser.id
					)
				);
		},
		isOneHourAfter(creationDate, ele) {
			if (ele.type == "NewContract") {
				let x = new Date(creationDate).toLocaleString().split(" "); //changing date into local string
				let createdDate = moment(x[0]);
				// start time and end time
				var createdTime = moment(x[1], "HH:mm:ss");
				var nowTime = moment(moment().format("HH:mm:ss"), "HH:mm:ss");
				if (moment().isAfter(createdDate) && nowTime.isAfter(createdTime))
					return true;
				else return false;
			} else {
				return true;
			}
		},

		elapsedTime(startTime) {
			let x = new Date(moment(startTime).local().format("YYYY-MM-DD HH:mm:ss"));
			let now = new Date();
			var timeDiff = now - x;
			timeDiff /= 1000;

			var seconds = Math.round(timeDiff);
			timeDiff = Math.floor(timeDiff / 60);

			var minutes = Math.round(timeDiff % 60);
			timeDiff = Math.floor(timeDiff / 60);

			var hours = Math.round(timeDiff % 24);
			timeDiff = Math.floor(timeDiff / 24);

			var days = Math.round(timeDiff % 365);
			timeDiff = Math.floor(timeDiff / 365);

			var years = timeDiff;

			if (years > 0) {
				return years + (years > 1 ? " ans" : " an");
			} else if (days > 0) {
				return days + (days > 1 ? " jours" : " jour");
			} else if (hours > 0) {
				return hours + (hours > 1 ? " heures" : " heure");
			} else if (minutes > 0) {
				return minutes + (minutes > 1 ? " minutes" : " minute");
			} else if (seconds > 0) {
				return seconds + (seconds > 1 ? " sec" : "maintenant");
			}

			return "Maintenant";
		},
		// Method for creating dummy notification time
		randomDate({ hr, min, sec }) {
			let date = new Date();

			if (hr) date.setHours(date.getHours() - hr);
			if (min) date.setMinutes(date.getMinutes() - min);
			if (sec) date.setSeconds(date.getSeconds() - sec);

			return date;
		},
		showAllNotificationTapped() {
			this.showAllNotificationPopUp = true;
			this.showAllNotification = true;
			this.refreshKey++;
		},
	},
	updated() {
		this.notifPopup = $(".notification-menu").is(":visible");
	},
	mounted() {
		var main = function () {
			$("#notif_icon").click(function () {
				$(".notification-menu").toggle();
			});
			$("#notif_icon").click(function () {
				$(".notification-menu-header").toggle();
			});
			$("#notif_icon").click(function () {
				$(".notification-menu-footer").toggle();
			});

			$(".post .btn").click(function () {
				$(this).toggleClass("btn-like");
			});
		};
		$(document).ready(main);
	},
};
</script>
  <style lang="scss">
// Global
html,
body {
	margin: 0;
	padding: 0;
}

body {
	background-color: #f5f5f5;
}

.container {
	max-width: 700px;
	margin: 0 auto;
}
.fixed {
	position: -webkit-sticky;
	position: sticky;
	bottom: 0;
	background-color: #111;
	color: #f2f2f2;
}
.notification-container {
	height: 70px;
	flex-wrap: wrap;
	align-items: center !important;
	justify-items: center !important;
	display: flex !important;
	justify-content: space-between !important;
	width: 100% !important;
}

.borderlist {
	border-bottom: 0.5px solid rgb(204, 204, 204);
	list-style-position: outside;
}

.notification {
	position: relative;
	text-align: left;
}
.notification-top {
	height: 7vh;

	display: flex;
	justify-content: center;
}
.notification-dowm {
	height: 30px;

	display: flex;
	justify-content: center;
}

.notification img {
	padding: 10px 0;
}

.notification-menu-footer {
	position: absolute;
	top: 430px;
	right: -10px;
	background-color: #e5e5e5;
	list-style: none;
	width: 400px;
	overflow: auto;
	display: none;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

	border-bottom-right-radius: 5px;
	border-bottom-left-radius: 5px;

	text-align: left;
}
.notification-menu-header {
	position: absolute;
	top: 50px;
	right: -10px;
	background-color: #e5e5e5;
	list-style: none;
	width: 400px;
	overflow: auto;
	display: none;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

	border-top-right-radius: 5px;
	border-top-left-radius: 5px;

	text-align: left;
}
.notification-menu {
	position: absolute;
	top: 80px;
	right: -10px;
	background-color: #e5e5e5;
	list-style: none;
	width: 400px;
	overflow: auto;
	display: none;
	height: 300px;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

	text-align: left;
}

.notification-menu li {
	background-color: #fff;
}

.notification-menu .avatar {
	padding: 2px 0;
}

.notification-menu h3 {
	font-size: 15px;
	margin: 0 0 5px 0;
	display: inline;
}

.notification-menu p {
	margin-bottom: 0;
	font-size: 14px;
}

.post {
	background-color: #fff;
	padding: 20px;
	margin: 20px 0;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
}

.post .avatar {
	padding-right: 10px;
	padding-bottom: 5px;
}

.post h3 {
	font-size: 16px;
	margin-top: 0;
	display: inline;
}

.post p {
	font-size: 14px;
}

.post p + img {
	width: 100%;
	margin-bottom: 15px;
}
.feather-icon-badge {
	background-color: red !important;
}

.btn {
	color: #333;
	background-color: transparent;
	font-weight: 600;
}

.btn-like {
	background-color: #cc0000;
	border-color: #b20000;
	color: #fff;
}
::-webkit-scrollbar {
	width: 10px;
}

::-webkit-scrollbar-track {
	background-color: transparent;
}

::-webkit-scrollbar-thumb {
	background-color: #d6dee1;
	border-radius: 10px;
	border: 2px solid transparent;
	background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
	background-color: #a8bbbf;
}
</style>


